.pageLoaderContainer {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 100vh;
}
